import { render, staticRenderFns } from "./AccordionInfo.vue?vue&type=template&id=f6d1dcee&"
import script from "./AccordionInfo.vue?vue&type=script&lang=js&"
export * from "./AccordionInfo.vue?vue&type=script&lang=js&"
import style0 from "./AccordionInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports